import React, { useEffect } from "react";
import { IAudioComponent } from "../../../../interfaces/sw/SWInterfaces";
import "./Audio.scoped.scss";
import { useDispatch } from "react-redux";
import { ImageDataDestinations } from "../../../../store/manageSW/manageSWTypes";
import BlockSpinner from "../../../common/BlockSpinner";
import { getAudioUrl } from "../../../../store/manageSW/manageSWActions";
import useSelector from "../../../../store/useSelector";

interface IAudioProps {
    swGuid: string,
    swVersion: number,
    component: IAudioComponent,
    stepGuid: string,
}

const Audio: React.FC<IAudioProps> = ({ swGuid, swVersion, component, stepGuid }) => {
    const { fileUploadOperation } = useSelector(store => store.manageSW);
    const dispatch = useDispatch();

    useEffect(() => {
        if (!component.filename
            || component.blobData?.isLoading
            || component.filename === component.blobData?.filename
            || fileUploadOperation?.isWorking) {
            // blobl url already loaded. ignore.
            return;
        }

        dispatch(getAudioUrl({
            swGuid,
            swVersion,
            stepGuid,
            componentGuid: component.guid,
            filename: component.filename,
            destination: ImageDataDestinations.ManageSW,
        }));
    }, [component, stepGuid, swGuid, swVersion, fileUploadOperation, dispatch]);

    if (component.blobData?.isLoading) {
        return (
            <div
                className="image-holder"
            >
                <BlockSpinner />
            </div>
        );
    } else if (component.blobData?.blobUrl) {
        return (
            <audio controls className="embed">
                <source src={component.blobData?.blobUrl} />
            </audio>
        );
    } else if (component.blobData?.errorMessage) {
        return (
            <div
                className="embed empty"
            >
                <span>
                    {component.blobData?.errorMessage}
                </span>
            </div>
        );
    } else {
        return null;
    }
}

export default Audio;